import { render, staticRenderFns } from "./PurchaseOrders.vue?vue&type=template&id=ea0d52fa&"
import script from "./PurchaseOrders.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrders.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports